/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Tabs, Tab,
} from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import CRUDDeleteDialog from './CRUDDeleteDialog';
import { AppState } from '../../state/MyStateProvider';
import {
  crudDeleteOptionsPropTypes,
  defaultCrudDeleteOptionsPropTypes,
} from './crud-prop-types';
import pageUtilsPropTypes from '../page-prop-types';
import MyTable from '../../widgets/table/MyTable';
import { myTableHeadCellPropTypes } from '../../widgets/table/my-table-prop-types';
import { defaultCrudRouteOptionsPropTypes, crudOptionsPropTypes } from '../../route/route-prop-types';
import CRUDFCreateFab from './crud-read-filtered-page.js/CRUDFCreateFab';
import { drawerRoutesPropTypes } from '../dashboard-3-drawers/d3d-prop-types';

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    marginBottom: theme.spacing(8),
  },
  tableRowListItem: {
    // backgroundColor: lighten(theme.palette.primary.main, 0.90),
  },
  tab: {
    color: theme.palette.text.secondary,
  },
  tabSelected: {
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.background.default,
  },
}));

const CRUDReadFilteredPage = (props) => {
  const {
    pageUtils,
    isLoading,
    tableColumns,
    Repository,
    routes,
    labelIds,
    deleteOptions,
    DetailDialog,
    crudOptions,

    defaultOrderBy,
    defaultOrderDirection,
    defaultPage,
    defaultRowsPerPage,
    rowsPerPageOptions,

    isUseTab,
    tabs,
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
  } = props;
  const { state } = React.useContext(AppState);
  const history = useHistory();
  const classes = useStyles();
  const intl = useIntl();
  const location = useLocation();

  const {
    create: createOptions,
    detail: detailOptions,
    edit: editOptions,
    delete: crudDeleteOptions,
  } = crudOptions;

  // Tabs
  const [tabIndex, setTabIndex] = React.useState(0);

  // Table
  const [repo] = React.useState(new Repository(state));
  const tableRef1 = React.useRef(null);
  const tableRef2 = React.useRef(null);
  const tableRefs = [tableRef1, tableRef2];

  // Detail dialog
  const [openDetailDialog, setOpenDetailDialog] = React.useState(false);
  const [detailData, setDetailData] = React.useState(null);

  // Delete dialog
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [deleteTitle, setDeleteTitle] = React.useState('');
  const [deleteSubtitle, setDeleteSubtitle] = React.useState('');
  const [deleteThumb, setDeleteThumb] = React.useState(null);

  const handleOpenDetailDialog = (data, open) => {
    setDetailData(data);
    setOpenDetailDialog(open);
  };

  const handleClickDetail = (rowData) => {
    if (detailOptions.type === 'routeDialog') {
      const detailPath = routes.detail.path.replace(':id', rowData._id);
      history.push({
        pathname: detailPath,
        state: {
          background: location,
          modal: routes.detail.path,
        },
      });
    } else if (detailOptions.type === 'route') {
      const detailPath = routes.detail.path.replace(':id', rowData._id);
      history.push(detailPath);
    } else {
      handleOpenDetailDialog(rowData, true);
    }
  };


  const handleOpenDeleteDialog = (rowData, open) => {
    if (rowData) {
      setDeleteId(rowData._id);
      if (deleteOptions.title) {
        if (typeof deleteOptions.title === 'string') {
          setDeleteTitle(rowData[deleteOptions.title]);
        } else if (typeof deleteOptions.title === 'function') {
          setDeleteTitle(deleteOptions.title(rowData));
        }
      }
      if (deleteOptions.subtitle) {
        if (typeof deleteOptions.subtitle === 'string') {
          setDeleteSubtitle(rowData[deleteOptions.subtitle]);
        } else if (typeof deleteOptions.subtitle === 'function') {
          setDeleteSubtitle(deleteOptions.subtitle(rowData));
        }
      }
      if (deleteOptions.thumb) {
        if (typeof deleteOptions.thumb === 'string') {
          setDeleteThumb(rowData[deleteOptions.thumb]);
        } else if (typeof deleteOptions.thumb === 'function') {
          setDeleteThumb(deleteOptions.thumb(rowData));
        }
      }
    } else {
      setDeleteId(null);
      setDeleteTitle('');
      setDeleteSubtitle('');
      setDeleteThumb(null);
    }
    setOpenDeleteDialog(open);
  };

  const handleRefreshTable = () => {
    if (tableRefs) {
      tableRefs[tabIndex].current.refresh();
    }
  };

  const handleDelete = () => {
    pageUtils.loadSomething(
      () => repo.deleteById(deleteId),
      () => {
        handleOpenDeleteDialog(null, false);
        handleRefreshTable();
      },
      labelIds.successDelete,
      labelIds.errorDelete,
    );
  };

  const handleTableLoadDataTab = (getAll) => (page, rowsPerPage, orderBy, orderDirection) => {
    if (getAll) {
      return getAll(repo, page + 1, rowsPerPage, orderBy, orderDirection);
    }
    return repo.getFiltered(page + 1, rowsPerPage, orderBy, orderDirection);
  };

  let tableTabs = tabs;
  if (!isUseTab) {
    tableTabs = [
      {
        getAll: null,
        labelIds: {
          tab: labelIds.title,
        },
      },
    ];
  }

  return (
    <Dashboard3Drawers
      AuthenticationRepository={AuthenticationRepository}
      routes={drawerRoutes}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      titleId={routes.index.titleId}
      isLoading={isLoading}
      usePaddingContent={false}
    >
      {
        isUseTab ? (
          <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
          >
            {
            tableTabs.map((tab) => (
              <Tab
                classes={{ root: classes.tab, selected: classes.tabSelected }}
                label={<FormattedMessage id={tab.labelIds.tab} />}
                key={`myTable-crud-read-filtered-page-tab-${tab.labelIds.tab}`}
              />
            ))
          }
          </Tabs>
        ) : <span />
      }
      <div className={classes.tableWrapper}>
        <div>
          {
            tableTabs.map((tab, index) => (
              <div
                key={`myTable-crud-read-filtered-page-tab-panel-${tab.labelIds.tab}`}
                hidden={tabIndex !== index}
                value={tabIndex}
              >
                <MyTable
                  id={`myTable-crud-read-filtered-page-${tab.labelIds.tab}`}
                  ref={tableRefs[index]}
                  titleId={tab.labelIds.tab}
                  headers={tableColumns}
                  pageUtils={pageUtils}
                  loadData={handleTableLoadDataTab(tab.getAll)}
                  defaultOrderBy={defaultOrderBy}
                  defaultOrderDirection={defaultOrderDirection}
                  defaultPage={defaultPage}
                  defaultRowsPerPage={defaultRowsPerPage}
                  icons={icons}
                  onClickRow={detailOptions.enabled
                    ? (e, rowData) => handleClickDetail(rowData) : undefined}
                  enableEdit={editOptions.enabled}
                  onEdit={editOptions.enabled
                    ? (e, rowData) => history.push(routes.edit.path.replace(':id', rowData._id)) : undefined}
                  enableDelete={crudDeleteOptions.enabled}
                  onDelete={crudDeleteOptions.enabled
                    ? (e, rowData) => handleOpenDeleteDialog(rowData, true) : undefined}
                  rowsPerPageOptions={rowsPerPageOptions}
                />
              </div>
            ))
          }
        </div>
        {
          createOptions.enabled
            ? (
              <CRUDFCreateFab
                path={routes.create.path}
                icons={icons}
              />
            ) : ''
        }
      </div>
      <CRUDDeleteDialog
        open={openDeleteDialog}
        onClose={() => handleOpenDeleteDialog(null, false)}
        onDelete={handleDelete}
        isLoading={isLoading}
        name={intl.formatMessage({ id: labelIds.name })}
        title={deleteTitle}
        subtitle={deleteSubtitle}
        thumb={deleteThumb}
      />
      {
        DetailDialog
          ? (
            <DetailDialog
              open={openDetailDialog}
              onClose={() => handleOpenDetailDialog(null, false)}
              data={detailData}
              isLoading={isLoading}
              pageUtils={pageUtils}
              onRefresh={handleRefreshTable}
              icons={icons}
            />
          )
          : <span />
      }

    </Dashboard3Drawers>
  );
};

CRUDReadFilteredPage.propTypes = {
  Repository: PropTypes.func.isRequired,
  routes: PropTypes.shape({
    index: PropTypes.shape({
      titleId: PropTypes.string,
      detailType: PropTypes.string,
    }),
    detail: PropTypes.shape({
      path: PropTypes.string,
    }),
    create: PropTypes.shape({
      path: PropTypes.string,
    }),
    edit: PropTypes.shape({
      path: PropTypes.string,
    }),
  }).isRequired,
  pageUtils: pageUtilsPropTypes.isRequired,
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape(myTableHeadCellPropTypes),
  ),
  labelIds: PropTypes.shape({
    errorLoad: PropTypes.string.isRequired,
    errorDelete: PropTypes.string,
    successDelete: PropTypes.string,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,

  isLoading: PropTypes.bool,
  crudOptions: crudOptionsPropTypes,
  deleteOptions: crudDeleteOptionsPropTypes,
  DetailDialog: PropTypes.func,

  defaultOrderBy: PropTypes.string,
  defaultOrderDirection: PropTypes.string,
  defaultPage: PropTypes.number,
  defaultRowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),

  isUseTab: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      getAll: PropTypes.func.isRequired,
      labelIds: PropTypes.shape({
        tab: PropTypes.string.isRequired,
      }),
    }),
  ),
  AuthenticationRepository: PropTypes.func.isRequired,
  drawerRoutes: drawerRoutesPropTypes.isRequired,
  applicationName: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  icons: PropTypes.objectOf(PropTypes.object).isRequired,
};

CRUDReadFilteredPage.defaultProps = {

  isLoading: false,
  crudOptions: defaultCrudRouteOptionsPropTypes,
  deleteOptions: defaultCrudDeleteOptionsPropTypes,
  DetailDialog: undefined,

  tableColumns: [],
  defaultOrderBy: undefined,
  defaultOrderDirection: undefined,
  defaultPage: undefined,
  defaultRowsPerPage: undefined,
  rowsPerPageOptions: undefined,

  isUseTab: false,
  tabs: [],
};

export default CRUDReadFilteredPage;
